import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/slices/cartSlice";
import styled from "styled-components";
import { FiBook } from "react-icons/fi";
import { Sizes } from "../utils/sizes";
import { Colors } from "../utils/colors";

const SectionStyle = styled.section`
  padding-top: 0;
  width: 100%;
  background-image: url("imageSection1.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      105deg,
      rgba(10,10,10,0.92) 0%,
      rgba(10,10,10,0.70) 55%,
      rgba(10,10,10,0.20) 100%
    );
  }
`;

const Inner = styled.div`
  position: relative;
  z-index: 1;
  width: 88%;
  max-width: 1100px;
  padding: 60px 0 80px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    width: 92%;
    padding: 48px 0 60px;
    text-align: center;
  }
`;

const Brand = styled.h1`
  color: #fff;
  font-size: clamp(2.4rem, 6vw, 4rem);
  font-weight: 900;
  line-height: 1;
  margin: 0 0 24px;
  letter-spacing: -1px;

  span { color: ${Colors.yellow}; }
`;

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,215,0,0.1);
  border: 1px solid rgba(255,215,0,0.3);
  color: ${Colors.yellow};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 5px 14px;
  border-radius: 20px;
  margin-bottom: 22px;
`;

const Headline = styled.h2`
  color: #fff;
  font-size: clamp(2.2rem, 5vw, 3.6rem);
  font-weight: 900;
  line-height: 1.1;
  margin: 0 0 20px;

  span { color: ${Colors.yellow}; }
`;

const Sub = styled.p`
  color: rgba(255,255,255,0.7);
  font-size: 1.1rem;
  line-height: 1.7;
  max-width: 540px;
  margin: 0 0 36px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    margin: 0 auto 36px;
  }
`;

const PriceAnchor = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    justify-content: center;
  }

  .original {
    color: rgba(255,255,255,0.5);
    font-size: 0.95rem;
    text-decoration: line-through;
  }

  .discount {
    background: rgba(255,215,0,0.12);
    color: ${Colors.yellow};
    font-size: 11px;
    font-weight: 800;
    padding: 3px 10px;
    border-radius: 20px;
  }
`;

const CtaRow = styled.div`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    justify-content: center;
  }
`;

const BtnPrimary = styled.button`
  background: ${Colors.yellow};
  color: #0a0a0a;
  border: none;
  padding: 16px 36px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 800;
  cursor: pointer;
  letter-spacing: 0.4px;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(255,215,0,0.35);
  }
`;

const BtnSecondary = styled.button`
  background: transparent;
  color: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  padding: 16px 36px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: ${Colors.yellow};
    color: ${Colors.yellow};
  }
`;


const Stats = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 40px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    justify-content: center;
  }

  .stat {
    .num { color: ${Colors.yellow}; font-size: 1.6rem; font-weight: 900; }
    .lbl { color: rgba(255,255,255,0.55); font-size: 0.78rem; text-transform: uppercase; letter-spacing: 1px; }
  }
`;

const Section = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleComprar = () => {
    dispatch(addToCart({
      id: 'colecao-completa-13-1',
      title: 'COLEÇÃO COMPLETA: 13 EM 1',
      price: 7990,
      category: 'Coleções',
    }));
    navigate('/checkout');
  };

  return (
    <SectionStyle>
      <Inner>
        <Brand>Violão <span>Católico</span></Brand>
        <Tag><FiBook size={13} /> Mais de 500 cifras católicas</Tag>
        <Headline>
          Toque músicas católicas<br />
          com <span>confiança</span> e técnica
        </Headline>
        <Sub>
          13 e-books com cifras para todos os tempos litúrgicos — Advento,
          Natal, Quaresma, Páscoa e muito mais. Do básico ao avançado.
        </Sub>

        <PriceAnchor>
          <span className="original">De R$ 149,90</span>
          <span className="discount">47% OFF</span>
        </PriceAnchor>

        <CtaRow>
          <BtnPrimary onClick={handleComprar}>
            COMPRAR COLEÇÃO — R$ 79,90
          </BtnPrimary>
          <BtnSecondary onClick={() => navigate('/loja')}>
            Ver todos os e-books
          </BtnSecondary>
        </CtaRow>

        <Stats>
          <div className="stat">
            <div className="num">500+</div>
            <div className="lbl">Cifras</div>
          </div>
          <div className="stat">
            <div className="num">13</div>
            <div className="lbl">e-Books</div>
          </div>
          <div className="stat">
            <div className="num">2k+</div>
            <div className="lbl">Videoaulas</div>
          </div>
        </Stats>

      </Inner>
    </SectionStyle>
  );
};

export default Section;
